import { SALES_API_BASE_URL } from "app/pages/sales-intelligence/constants/api";
import type { IFetchService } from "app/services/fetchService";

import type { Playbook, PlaybookRequest } from "../../types/playbooks.types";

export type PlaybooksApiService = {
    fetchPlaybooks(): Promise<Playbook[]>;
    fetchPlaybook(playbookId: number): Promise<Playbook>;
    createPlaybook(payload: PlaybookRequest): Promise<Playbook>;
    updatePlaybook(playbookId: number, payload: PlaybookRequest): Promise<Playbook>;
    deletePlaybook(playbookId: number): Promise<void>;
};

const PLAYBOOKS_BASE_URL = `${SALES_API_BASE_URL}/playbooks`;

const createPlaybooksApiService = (fetchService: Readonly<IFetchService>): PlaybooksApiService => {
    return {
        fetchPlaybooks() {
            return fetchService.get<Playbook[]>(PLAYBOOKS_BASE_URL);
        },
        fetchPlaybook(playbookId) {
            return fetchService.get<Playbook>(`${PLAYBOOKS_BASE_URL}/${playbookId}`);
        },
        createPlaybook(payload) {
            return fetchService.post<Playbook>(PLAYBOOKS_BASE_URL, payload);
        },
        updatePlaybook(playbookId, payload) {
            return fetchService.put<Playbook>(`${PLAYBOOKS_BASE_URL}/${playbookId}`, payload);
        },
        deletePlaybook(playbookId) {
            return fetchService.delete<void>(`${PLAYBOOKS_BASE_URL}/${playbookId}`);
        },
    };
};

export default createPlaybooksApiService;
